import { Button, Dropdown, Menu } from 'antd';
import React from 'react';

import { WorkerTimesheetActions } from '@common/graphql/schema';
import { isPastApproval } from '@timekeeping/services';
import { Icon } from '@common/components';

export const DropdownButtons = ({
  onAction,
  timesheet,
  loading,
}: {
  loading: WorkerTimesheetActions | undefined;
  onAction: (action: WorkerTimesheetActions) => void;
  timesheet: {
    canApprove: { value: boolean };
    canReject: { value: boolean };
    canUnapprove: { value: boolean };
    submittedAtTimesheet?: { pastApprovalDeadline: boolean } | null;
    status: string;
  };
}) => {
  const menu = (
    <Menu>
      {timesheet.canApprove.value && (
        <Menu.Item className="worker-timesheet-approve-button">
          <a onClick={() => onAction('approve')}>Approve</a>
        </Menu.Item>
      )}
      {timesheet.canReject.value && (
        <Menu.Item className="worker-timesheet-reject-button">
          <a onClick={() => onAction('reject')}>Reject</a>
        </Menu.Item>
      )}
      {timesheet.canUnapprove.value && (
        <Menu.Item className="worker-timesheet-unapprove-button">
          <a onClick={() => onAction('unapprove')}>Unapprove</a>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <Dropdown
      className="worker-timesheet-actions-dropdown"
      overlay={menu}
      trigger={['click']}
      getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
    >
      <Button
        loading={!!loading}
        type={isPastApproval(timesheet) ? 'primary' : 'default'}
      >
        <span style={{ marginRight: 8 }}>Actions</span>
        <Icon icon="chevronDown" kind="light" />
      </Button>
    </Dropdown>
  );
};
